import { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import ResourceTable from "./ResourceList/ResourceTable/ResourceTable";
import DMSHeader from "../DMSHeader/DMSHeader";
import { useTranslation } from 'react-i18next';

// Main component for managing resources in the application
const ResourceManagement = () => {
  // Translation hook for internationalization
  const { t } = useTranslation();

  // Initialize GridStack layout system on component mount
  useEffect(() => {
    GridStack.init();
  }, []);
  const location = useLocation();

  // Layout configuration for the grid items, Defines position, size
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t('resource_management_header')}
          fileName="ResourceManagement"
          showmenu={true}
          showImportDropDownLabel={false}
          showdownload={true}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <ResourceTable locationInstance={location.state} />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ResourceManagement;